<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> ผลผลิต /
          ตัวชี้วัดความสำเร็จ
        </div>

        <v-btn
          icon
          :class="{ rotate180: OOIExpanded }"
          @click="OOIExpanded = !OOIExpanded"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
          ></Iconify>
        </v-btn>
      </div>


        <!-- Form 1 -->
        <div
        class="card-part expandable pt-0"
        :class="{ 'expanded mt-3': OOIExpanded }"
      >
          <div class="txt-head black--text mb-5">
            1. ตัวชี้วัดความสำเร็จ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex flex-column gap-16">
            <!--   ผลผลิต   -->
              <div v-for="(item, i) in masterData.kpi_masters" :key="i">
              <div class="mb-3 black--text txt-bigger">
                ตัวชี้วัดที่ {{ item.no }} {{ item.name }}
              </div>

              <template v-for="(sub, ind) in item.kpi_sub_masters">
                <OOILineField
                  :key="ind"
                  :id="sub.no"
                  :label="sub.name"
                  :unit="sub.unit"
                  :desc_flag="sub.desc_flag"
                  :desc_label="sub.desc_label"
                  :desc_value="kpi[sub.id] ? kpi[sub.id].description : null"
                  :readonly="sub.disabled_on_submit_flag === 1 ? true : false"
                  :field="
                    sub.disabled_on_submit_flag === 1
                      ? calculateKPITotal(item)
                      : kpi[sub.id]
                      ? kpi[sub.id].kpi_sub_value
                      : ''
                  "
                  :disabled="isOIC"
                  @onChange="setKpiField(sub.id, $event)"
                  @onFocusOut="checkLessThanBefore(sub.id)"
                  @onDescChange="setKpiDescription(sub.id, $event)"
                ></OOILineField>

                <div
                  v-if="item.no === '80' && ind === 0"
                  :key="'label80-' + ind"
                  class="pt-2 pl-16"
                  style="height: 60px"
                >
                  ค่าใช้จ่ายคงที่ของแผนงาน INFRA ได้แก่
                </div>
                
                <OOILineField
                  v-if="item.no === '80' && ind === item.kpi_sub_masters.length - 2"
                  :key="'sum80-' + ind"
                  label="รวม"
                  unit="บาท"
                  :field="calculateExpenseSum(item)"
                  :readonly="true"
                ></OOILineField>
              </template>

              <!--              <OOILineField-->
              <!--                  label="รวม"-->
              <!--                  :readonly="true"-->
              <!--                  :field="Object.values(kpi).map(x => x.kpi_sub_amount).reduce((a, b) => a + b, 0)"-->
              <!--              ></OOILineField>-->
            </div>
          </div>
        </div>
      </div>
    </divcard>
    <!-- 4. หากไม่ได้เข้ารับบริการกับทางอุทยานวิทยาศาสตร์ภูมิภาค -->
    <divcard
    v-if="isOIC"
    noPadding
    >
      <div class="card-part " >
        <div>
          <div class="mb-5 d-flex justify-space-between" style="width:100%; padding:4px 24px; ">
            <span class="black--text txt-head" >
              ความคิดเห็น/ข้อเสนอแนะ
            </span>
            <v-btn
          icon
          :class="{ rotate180: OOI2Expanded }"
          @click="OOI2Expanded = !OOI2Expanded"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
          ></Iconify>
        </v-btn>
          </div>
      <!-- <v-divider v-if="OOI2Expanded" class="mt-4 mb-8 "></v-divider> -->
          <div
        class="card-part expandable pt-0"
        :class="{ 'expanded ': OOI2Expanded }"
      >
          <TextArea
          style="padding:12px 24px;"
            theme="3"
            height="120"
            :value="form?.ops_comment"
            @onChange="setFormField('ops_comment', $event)"
          ></TextArea>
        </div>
      </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import OOILineField from "../../../components/OOILineField";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import Wysiwyg from "@/components/input/Wysiwyg.vue";
import Button from "@/components/input/Button.vue";

export default {
  name: "DFormOOI",
  components: {
    Button,
    Wysiwyg,
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    OOILineField,
  },
  props: {
    masterData: {
      default: () => ({
        
      }),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {},
      OOIExpanded: true,
      OOI2Expanded: true,
      kpi: {},
      plan_code: "",
      OOIs: [
        {
          kpi_id: 60,
          kpi_name: "จำนวนผู้เข้าร่วมโครงการ IRTC ต่อปี",
          sub: [
            {
              kpi_sub_name: "มีผู้เข้าร่วมโครงการ IRTC ประเภทนิติบุคคล",
            },
          ],
        },
        {
          kpi_id: 61,
          kpi_name:
            "ผลกระทบเชิงเศรษฐกิจรวมที่เกิดขึ้นจาก IRTC ที่สามารถคำนวณได้ในปี",
          sub: [
            {
              kpi_sub_name: "มูลค่าของการเพิ่มกำลังการผลิต",
            },
            {
              kpi_sub_name: "มูลค่าของการลดต้นทุนในการผลิต",
            },
            {
              kpi_sub_name:
                "มูลค่าของการเพิ่มประสิทธิภาพหรือคุณภาพของผลิตภัณฑ์",
            },
            {
              kpi_sub_name:
                "มูลค่ายอดขายของผลิตภัณฑ์ที่เกิดขึ้นจริงหลังเข้าโครงการ",
            },
            {
              kpi_sub_name: "มูลค่าของกระบวนการผลิตใหม่ที่มีการผลิตจริง",
            },
          ],
        },
        {
          kpi_id: 62,
          kpi_name: "มูลค่าการลงทุน R&D ของผู้ประกอบการ IRTC ต่อปี",
          sub: [
            {
              kpi_sub_name: "ค่าใช้จ่ายที่เป็นเงินสด (in cash) ของโครงการ IRTC",
            },
            {
              kpi_sub_name:
                "ค่าใช้จ่ายที่เกี่ยวกับเครื่องมืออุปกรณ์วิจัยพัฒนาที่ใช้ในโครงการ",
            },
            {
              kpi_sub_name:
                "ค่าใช้จ่ายในการจัดทำหรือปรับปรุงสถานที่เพื่อดำเนินโครงการ",
            },
            {
              kpi_sub_name: "ค่าใช้จ่ายในการจ้างบุคลากรวิจัยรวมในปีที่ประเมิน",
            },
          ],
        },
        {
          kpi_id: 63,
          kpi_name:
            "คะแนนเฉลี่ยของระดับของเทคโนโลยีที่ผู้ประกอบการ IRTC นำมาใช้",
          sub: [
            {
              kpi_sub_name: "ระดับความสามารถของเทคโนโลยี (Functionality)",
            },
            {
              kpi_sub_name:
                "ระดับความก้าวหน้าของเทคโนโลยี (Newness, Advancement and Trend)",
            },
            {
              kpi_sub_name: "ระดับความง่ายในการใช้เทคโนโลยี (Usability)",
            },
            {
              kpi_sub_name:
                "ระดับการปรับขนาดไปสู่การผลิตเชิงพาณิชย์ (Scalability)",
            },
            {
              kpi_sub_name:
                "ระดับความสามารถในการแข่งขันของเทคโนโลยี (Competitiveness)",
            },
          ],
        },
      ],
      annexFiles: [],
      companyList: [],
      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) =>
          !value || value.size <= 50000000 || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],

      // incubation_companies
      is_incubation_company_form: false,
      incubation_companies: [],
      valid_incubation_company: true,
      university_masters: [],
      company_masters: [
          "อุตสาหกรรมยานยนต์สมัยใหม่ (Next-generation Automotive)",
          "อุตสาหกรรมอิเล็กทรอนิกส์อัจฉริยะ (Smart Electronics)",
          "อุตสาหกรรมการท่องเที่ยวกลุ่มรายได้ดีและการท่องเที่ยวเชิงสุขภาพ (Affluent, Medical and Wellness Tourism)",
          "การเกษตรและเทคโนโลยีชีวภาพ (Agriculture and Biotechnology)",
          "อุตสาหกรรมการแปรรูปอาหาร (Food for the Future)",
          "อุตสาหกรรมหุ่นยนต์ (Robotics)",
          "อุตสาหกรรมการบินและโลจิสติกส์ (Aviation and Logistics)",
          "อุตสาหกรรมเชื้อเพลิงชีวภาพและเคมีชีวภาพ (Biofuels and Biochemicals)",
          "อุตสาหกรรมดิจิตอล (Digital)",
          "อุตสาหกรรมการแพทย์ครบวงจร (Medical Hub)",
          "อุตสาหกรรมอื่น (ระบุ)"
      ],
      status_masters: [
        "บ่มเพาะธุระกิจ วทน. ปีที่ 1",
        "บ่มเพาะธุระกิจ วทน. ปีที่ 2",
        "บ่มเพาะธุระกิจ วทน. ปีที่ 3",
      ],
      incubation_companie_form: {
        fiscal_year: "",
        university_id: "",
        university_name: "",
        product: "",
        company: "",
        technology_type: "",
        technology_type_other: "",
        status: "",
      },
      incubationCompanyMainIndex: null,
      incubationCompanyIndex: null,
    };
  },
  computed: {
    ...mapState({
      OOIForm: (state) => state.CForm.OOIForm,
      isOIC: state => state.Auth.User.user_type === 'สป.อว.'
    }),
    total: function () {
      return this.calculateKPITotal();
    },
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
    yearList() {
      let year = new Date().getFullYear();
      let yearList = [];
      year = year + 543;
      for (let i = 0; i < 10; i++) {
        yearList.push(year - i);
      }
      return yearList;
    },
  },
  created() {
    if (this.isSameId && !this.masterData.form_b) this.form = this.OOIForm;
    if (this.masterData.form_b) {
      this.setData()
    }
    eventBus.$on("aFormOOI", () => {
      eventBus.$emit("aFormOOISend", {
        ...this.form,
        attachments: this.annexFiles || [],
        completed_incubation_company: this.companyList || [],
        incubation_companies: this.flattenNestedArray(this.incubation_companies) || [],
        kpi_sub_values: Object.values(this.kpi),
      });
    });

    eventBus.$on("aFormOOISetData", () => this.setData());

    this.university_masters = this.masterData.university_masters;

    // this.groupIncubationCompany(data);
  },
  methods: {
    getUniversityName() {
      const university = this.university_masters.find(
        (x) => x.id === this.incubation_companie_form.university_id
      );
      this.incubation_companie_form.university_name = university
        ? university.name_th
        : "";
    },

    clearIncubationCompanyForm() {
      this.incubation_companie_form = {
        fiscal_year: "",
        university_id: "",
        university_name: "",
        product: "",
        company: "",
        technology_type: "",
        technology_type_other: "",
        status: "",
      };
      this.incubationCompanyMainIndex = null;
      this.incubationCompanySubIndex = null;
      this.is_incubation_company_form = false;
    },

    handleSubmitIncubationCompanyForm() {
      if (this.$refs.incubation_company_form.validate()) {
        if (
          this.incubationCompanyMainIndex != null &&
          this.incubationCompanySubIndex != null
        ) {
          this.updateIncubationCompany();
        } else {
          this.saveIncubationCompany();
        }
      }
    },

    saveIncubationCompany() {
      // เพิ่มข้อมูลใน array ของ incubation_companies ตามปีที่เลือก
      const index = this.incubation_companies.findIndex((e) => {
        return e[0] == this.incubation_companie_form.fiscal_year;
      });

      if (index === -1) {
        // ไม่เจอปีที่เลือกใน array ให้เพิ่มปีนั้นเข้าไป
        this.incubation_companies.push([
          this.incubation_companie_form.fiscal_year,
          [this.incubation_companie_form],
        ]);
      } else {
        // ถ้าเจอปีที่เลือกใน array ให้เพิ่มข้อมูลในปีนั้น
        this.incubation_companies[index][1].push(this.incubation_companie_form);
      }

      // เรียงข้อมูลใหม่ จากมากไปน้อย เช่น 2566, 2565
      this.incubation_companies.sort((a, b) => b[0] - a[0]);

      // ล้างข้อมูลใน form
      this.clearIncubationCompanyForm();
    },

    updateIncubationCompany() {

      // แก้ไขข้อมูลใน array ของ incubation_companies ตามปีที่เลือก
      this.incubation_companies[this.incubationCompanyMainIndex][1][
        this.incubationCompanySubIndex
      ] = this.incubation_companie_form;

      // เรียงข้อมูลใหม่ จากมากไปน้อย เช่น 2566, 2565
      this.incubation_companies.sort((a, b) => b[0] - a[0]);

      // ล้างข้อมูลใน form
      this.clearIncubationCompanyForm();
    },
    unflattenArray(input) {
      const output = [];

      for (const obj of input) {
        const fiscalYear = obj.fiscal_year;
        let yearGroup = output.find((group) => group[0] === fiscalYear);

        if (!yearGroup) {
          yearGroup = [fiscalYear, []];
          output.push(yearGroup);
        }

        yearGroup[1].push(obj);
      }

      return output;
    },
    flattenNestedArray(input) {
      const output = [];

      for (const item of input) {
        for (const obj of item[1]) {
          output.push(obj);
        }
      }

      return output;
    },
    editIncubationCompany(mainIndex, subIndex) {
      this.incubationCompanyMainIndex = mainIndex;
      this.incubationCompanySubIndex = subIndex;
      this.incubation_companie_form = this.incubation_companies[mainIndex][1][subIndex];
      this.incubation_companie_form.fiscal_year = this.incubation_companie_form.fiscal_year ? parseInt(this.incubation_companie_form.fiscal_year) : null
      this.is_incubation_company_form = true;
    },

    deleteIncubationCompany(mainIndex, subIndex) {
      this.incubation_companies[mainIndex][1].splice(subIndex, 1);

      // เช็คว่าถ้าข้อมูลในปีนั้นเป็นค่าว่างหมด ให้ลบปีนั้นออก
      if (this.incubation_companies[mainIndex][1].length === 0) {
        this.incubation_companies.splice(mainIndex, 1);
      }
    },

    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setData() {
      this.form = this.masterData.form_b.form_ab_general_info;
      for (const x of this.masterData.kpi_masters) {
        for (const y of x.kpi_sub_masters) {
          if (y.kpi_sub_values) {
            let subId = y.kpi_sub_values.kpi_sub_master_id.toString();
            this.kpi[subId] = {};
            this.kpi[subId].id = y.kpi_sub_values.id;
            this.kpi[subId].kpi_sub_master_id =
              y.kpi_sub_values.kpi_sub_master_id;
            this.kpi[subId].kpi_sub_value = y.kpi_sub_values.kpi_sub_value;
            this.kpi[subId].description = y.kpi_sub_values.description;
          }
        }
      }
      this.plan_code = this.masterData.plan_master.plan_code

    },
    setKpiField(subId, val) {
      // format {
      //   kpi_sub_master_id: '',
      //   kpi_sub_value: ''
      // }
      // this.kpi[subId] = {}
      if (!this.kpi[subId]) this.kpi[subId] = {};
      this.kpi[subId].kpi_sub_master_id = subId;
      this.kpi[subId].kpi_sub_value = val;
      this.$forceUpdate();
    },
    checkLessThanBefore(subId) {
      if (this.isFinal && (this.$route.query.id || this.masterData.updateId)) {
        // progress/final and update case
        let oldVal = this.masterData.form_b.kpi_sub_values_inception?.find(
          (x) => x.kpi_sub_master_id == subId
        )?.kpi_sub_value;
        if (oldVal && this.kpi[subId].kpi_sub_value < oldVal) {
          this.kpi[subId].kpi_sub_value = oldVal;
          console.log(
            "Cannot input less than before, value has been rollback."
          );
          this.$forceUpdate();
        }
      }
    },
    setKpiDescription(subId, val) {
      if (!this.kpi[subId]) this.kpi[subId] = {};
      this.kpi[subId].description = val;
      this.$forceUpdate();
    },
    calculateExpenseSum(item) {
      if (item.no !== '80' || item.kpi_sub_masters.length < 8) return 0;
      return [1, 2, 3, 4, 5, 6, 7].reduce((sum, idx) => {
        return sum + Number(this.kpi[item.kpi_sub_masters[idx].id]?.kpi_sub_value || 0);
      }, 0);
    },
    // Calculate sum by each KPI item
    calculateKPITotal: function (item) {
      let itemTotal = 0;
      switch (item.no) {
        case "64":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value == 0){
                itemTotal = 0;
              }else{
                itemTotal =
                (Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) *
                  100) /
                Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value);
              }
            }
          }
          break;
        case "65":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value == 0){
                itemTotal = 0;
              }else{
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) *
                    100) /
                  Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value);
              }
            }
          }
          console.log("itemTotal2", itemTotal)
          console.log("item.kpi_sub_masters[0].id]", this.kpi[item.kpi_sub_masters[0].id])
          console.log("item.kpi_sub_masters[1].id]", this.kpi[item.kpi_sub_masters[1].id])
          break;        
        case "72":
          if (item.kpi_sub_masters.length >= 3) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id] &&
              this.kpi[item.kpi_sub_masters[2].id]
            ) {
              const denominator72 =
                Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) +
                Number(this.kpi[item.kpi_sub_masters[2].id].kpi_sub_value);
              if (denominator72 == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value) /
                  denominator72) * 100;
              }
            }
          }
          break;
        case "79":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value) /
                  Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value)) * 100;
              }
            }
          }
          break;
        case "80":
          // สูตร: รายได้รวม - (ค่าเสื่อม+ค่าน้ำ+ค่าไฟ+ค่าซ่อม+เงินเดือนพนักงาน+แม่บ้าน+ค่าอื่นๆ)
          // index: 0=รายได้รวม, 1-7=ค่าใช้จ่ายคงที่, 8=ผลลัพธ์(calc/lastSub)
          if (item.kpi_sub_masters.length >= 9) {
            const totalCost80 =
              Number(this.kpi[item.kpi_sub_masters[1].id]?.kpi_sub_value || 0) +
              Number(this.kpi[item.kpi_sub_masters[2].id]?.kpi_sub_value || 0) +
              Number(this.kpi[item.kpi_sub_masters[3].id]?.kpi_sub_value || 0) +
              Number(this.kpi[item.kpi_sub_masters[4].id]?.kpi_sub_value || 0) +
              Number(this.kpi[item.kpi_sub_masters[5].id]?.kpi_sub_value || 0) +
              Number(this.kpi[item.kpi_sub_masters[6].id]?.kpi_sub_value || 0) +
              Number(this.kpi[item.kpi_sub_masters[7].id]?.kpi_sub_value || 0);

            // itemTotal → lastSub (sub[8]) = รายได้รวม - รวมค่าใช้จ่ายคงที่
            itemTotal = Number(this.kpi[item.kpi_sub_masters[0].id]?.kpi_sub_value || 0) - totalCost80;
          }
          break;
        // Other Case
        default:
          item.kpi_sub_masters.forEach((sub, index) => {
            if (index !== item.kpi_sub_masters.length - 1 && this.kpi[sub.id]) {
              itemTotal += Number(this.kpi[sub.id].kpi_sub_value);
            }
          });
          break;
      }

      // call setKpiField with the id of the last kpi_sub_master and the calculated itemTotal
      let lastSub = item.kpi_sub_masters[item.kpi_sub_masters.length - 1];
      if (
        lastSub &&
        lastSub.id &&
        (!this.kpi[lastSub.id] ||
          this.kpi[lastSub.id].kpi_sub_value != itemTotal)
      ) {
        this.setKpiField(lastSub.id, itemTotal);
      }

      return itemTotal;
    },
    addAnnexFile() {
      this.annexFiles.push({});
    },
    addToAttachment(index, file) {
      if(file.size > 50000000){
      this.$store.commit('General/setModal', {
        title: 'ขนาดไฟล์เกิน 50 MB',
        theme: 'warning',
        text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
        showCancel: false,
        buttonText: 'ตกลง'
      }) 
        this.annexFiles.pop()
        return
      }
      this.annexFiles[index] = file;
      this.$forceUpdate();
    },
    checkValType(val) {
      return typeof val;
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    removeFile(id) {
      this.annexFiles.splice(id, 1);
      this.$forceUpdate();
    },
    addCompanyList () {
      this.companyList.push({
        participants_year: '',
        participants_count: '',
      })
    },
    addToCompany (index, field, file) {
      this.companyList[index][field] = file
      this.form.completed_incubation_company = this.companyList
      this.$forceUpdate()
    },
    removeCompany(id) {
      console.log('before remove', this.companyList)
      this.companyList.splice(id, 1)
      this.form.completed_incubation_company = this.companyList
      console.log('after remove', this.companyList)
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss">
.incubation_companie_form {
  label {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }
  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px !important;
    border-radius: 30px;
  }

  .v-text-field--full-width .v-input__prepend-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer {
    margin-top: 8px !important;
  }
  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }
  i.v-icon.notranslate.mdi.mdi-calendar.theme--light {
    color: #f7941d !important;
  }
}
</style>
